<template>
  <!-- Teleport 로 항상 body 최상단에 -->
  <teleport to="body">
    <div
        v-if="visible"
        id="load"
        class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30"
        role="status"
        aria-live="polite"
        aria-busy="true"
    >
      <div class="load_wrap flex flex-col items-center gap-2">
        <!-- 기존 마크업 유지 -->
        <img src="@/assets/images/common/loading.gif" alt="loading" />
        <span>{{ message || 'loading' }}</span>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useLoadingStore } from '@/store/loading'

const loadingStore = useLoadingStore()
const { visible, message } = storeToRefs(loadingStore)
</script>
<style scoped>
.flex{
  display: flex;
}
.flex-col{
  flex-direction: column;
}
.items-center{
  align-items: center;
}
.gap-2{
  gap: 0.5rem;
}
.justify-center{
  justify-items: center;
}
</style>